/**
 * @param {string} orderId
 * @param {string} token
 * @param {string} [quoteName]
 * @param {{ openPdf?: boolean }} [options] — set `openPdf: true` to add `open_pdf=1` (auto-opens PDF on load)
 */
export function getShareUrl(orderId, token, quoteName = '', options = {}) {
  const { openPdf } = options;
  const base = window.location.origin + window.location.pathname;
  const params = new URLSearchParams();
  if (token) params.set('token', token);
  if (quoteName) params.set('quote_name', quoteName);
  if (openPdf) params.set('open_pdf', '1');
  const qs = params.toString();
  const hash = `#/draft-order/${orderId}`;
  return qs ? `${base}?${qs}${hash}` : `${base}${hash}`;
}






export function parseEmails(input) {
  if (!input || !String(input).trim()) return [];
  return String(input)
    .split(/[\s,;]+/)
    .map((e) => e.trim().toLowerCase())
    .filter((e) => e.length > 0 && e.includes('@'));
}


const isWithinSupportHours = (date = new Date()) => {
  // Example: Mon–Fri, 8:00–17:00 Central Time
  const zoned = new Date(date.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
  const day = zoned.getDay();        // 0=Sun, 1=Mon, ...
  const hour = zoned.getHours();     // 0–23

  const isWeekday = day >= 1 && day <= 5;
  const inHours = hour >= 8 && hour < 17;
  // console.log('isWithinSupportHours', isWeekday, 'hour', hour, 'inHours', inHours);
  // return false;
  return isWeekday && inHours;
};

/**
 * Open Gorgias chat widget if loaded. Returns a promise that resolves to true if opened, false if widget not available.
 * @param {string} [prefillMessage] - Optional message to send when chat opens (e.g. "Question about quote #1234")
 */
export function openGorgiasChat(prefillMessage) {
  if (!isWithinSupportHours()) {
    return Promise.resolve(false); // trigger handleAskQuestion fallback
  }

  // console.log('openGorgiasChat', isWithinSupportHours);

  const init = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise((resolve) => {
        window.addEventListener('gorgias-widget-loaded', () => resolve(), { once: true });
        setTimeout(() => resolve(), 3000);
      });

  return init
    .then(() => {
      if (typeof window.GorgiasChat?.open !== 'function') return false;
      window.GorgiasChat.setCurrentInput(`${prefillMessage}`);
      window.GorgiasChat.open();
      return true;
    })
    .catch(() => false);
}

export const klavityoPortalItems = (items) => {
  return items.map(function(product) {
    return {
      "ProductName": product.title,
      "ProductID": product.productLegacyResourceId,
      "SKU": product.sku,
      "VaritantID": product.variantId,
      "ItemPrice": product.price,
      "Quantity": product.quantity,
      "RowTotal": (product.price) * product.quantity,
      "Brand": product.vendor,
      "ProductURL": location.href.split( '/' )[0] + '//' + location.href.split( '/' )[2] + '/products/' + product.handle,
      "ImageURL": product.image,
    }
  });
}







